import { render, staticRenderFns } from "./PromoDetails.vue?vue&type=template&id=7695c51c"
import script from "./PromoDetails.vue?vue&type=script&lang=js"
export * from "./PromoDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports